// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"styles_layoutWrapper__HWUJ4","content":"styles_content__tUEtn","loading":"styles_loading__-Wgfw"};